export const VALID_PERCENTAGE_NUMBER =
	/^[+-]?(([1-9][0-9]*)?[0-9](\.[0-9]*)?|\.[0-9]+)$/;
